import React, { useState } from "react";
import { supabase } from "../supabaseclient";
import { setupAuthListener } from "../utils/authHelpers";

function AuthButton() {
  const [oauthError, setOauthError] = useState("");

  const handleLogin = async (provider) => {
    setOauthError("");
    // Use REACT_APP_SITE_URL for OAuth redirect so localhost works in dev (must be allowlisted in Supabase)
    const baseUrl =
      process.env.REACT_APP_SITE_URL || window.location.origin;
    const redirectTo = `${baseUrl.replace(/\/$/, "")}/complete-profile`;

    const { error } = await supabase.auth.signInWithOAuth({
      provider: provider,
      options: {
        redirectTo,
      },
    });
    if (error) {
      console.error("Error logging in:", error.message);
      setOauthError(
        error.message ||
          `${provider === "github" ? "GitHub" : "Google"} sign-in failed. Check that the provider is enabled in Supabase.`
      );
    }
  };

  React.useEffect(() => {
    const {
      data: { subscription },
    } = setupAuthListener();
    return () => subscription.unsubscribe();
  }, []);

  return (
    <div>
      {oauthError && (
        <div
          style={{
            color: "#c0392b",
            fontSize: "0.9rem",
            marginBottom: "0.75rem",
            padding: "0.5rem",
            backgroundColor: "#fde8e8",
            borderRadius: "4px",
          }}
        >
          {oauthError}
        </div>
      )}
      <button
        onClick={() => handleLogin("google")}
        style={{
          width: "100%",
          padding: "0.75rem",
          marginBottom: "0.5rem",
          backgroundColor: "#4285f4",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
        }}
      >
        <span>🔍</span> Sign in with Google
      </button>
      <button
        onClick={() => handleLogin("github")}
        style={{
          width: "100%",
          padding: "0.75rem",
          backgroundColor: "#333",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
        }}
      >
        <span>🐙</span> Sign in with GitHub
      </button>
    </div>
  );
}

export default AuthButton;
